import React from 'react'
import BreakoutModuleWide from '../BreakoutModuleWide'

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const BannerBreakoutModule = (props) => (
  <BreakoutModuleWide {...props} paddingV={1} hasGradient />
)

export default BannerBreakoutModule
